import selectors from '../../../../rootSelectors';
import { goToCountdown } from '../../../../common/navigation/navigationActions';
import { RCT, FLUENCY } from '../../../../constants/measure';
import { showQuestion, showSegment, setIsReadyScriptPlayed } from '../../../rctActions';
import {
    blockScreen, unblockScreen, activateNextButton, deactivateNextButton, greyOutScreen,
    enableDownButton,
} from '../../../../common/screen/screenActions';
import { GENERAL_AUDIO_DELAY } from '../../../../constants/time';
import { PRACTICE } from '../../../../constants/assessmentItemType';
import { playAvatarAudio, setAvatarInstructions } from '../../../../common/avatar/avatarActions';
import { activateReadyForNextScreen } from '../../../../common/questions/questionsActions';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';

const FLUENCY_AUDIO = RCT_AUDIO_INSTRUCTIONS.FLUENCY;

export const narrateActiveScript = (delay = GENERAL_AUDIO_DELAY) => (dispatch) => dispatch(playAvatarAudio([FLUENCY_AUDIO.practiceInstruction], delay));

export const narrateNextButtonScript = () => (dispatch) => dispatch(playAvatarAudio([FLUENCY_AUDIO.practiceComplete]));

export const onNextSegmentClick = () => (dispatch, getState) => {
    const state = getState();
    if (!selectors.hasNextSegment(state, PRACTICE)) {
        dispatch(blockScreen());
        dispatch(setAvatarInstructions(FLUENCY_AUDIO.clickOk));
        dispatch(activateNextButton());
        dispatch(narrateNextButtonScript())
            .then(() => {
                dispatch(unblockScreen());
            });
    } else {
        dispatch(enableDownButton());
    }
};

export const showNextElementOnDownButtonClick = () => (dispatch, getState) => {
    const state = getState();
    if (selectors.hasQuestion(state, PRACTICE)) {
        dispatch(showQuestion());
    } else {
        dispatch(onNextSegmentClick());
    }
};

export const showNextSegment = () => (dispatch, getState) => {
    const state = getState();
    if (selectors.hasNextSegment(state, PRACTICE)) {
        const nextSegmentIndex = selectors.getActiveSegmentIndex(state) + 1;
        dispatch(showSegment(nextSegmentIndex));
    }
};

export const handleNextClick = () => (dispatch, getStore) => {
    const state = getStore();
    if (!selectors.getQuestionsIsReadyForNextScreen(state)) {
        dispatch(blockScreen());
        dispatch(greyOutScreen());
        dispatch(deactivateNextButton());
        dispatch(setAvatarInstructions(FLUENCY_AUDIO.ready));
        return dispatch(playAvatarAudio([FLUENCY_AUDIO.ready]))
            .then(() => {
                dispatch(activateReadyForNextScreen());
                dispatch(activateNextButton());
                dispatch(unblockScreen());
            });
    }

    dispatch(setIsReadyScriptPlayed(true));
    return Promise.resolve()
        .then(() => {
            dispatch(goToCountdown(RCT, FLUENCY, 1));
        });
};
